import { ReactNode, JSX } from 'react';
import { IconStyle, UserType } from '@nextgen-web-framework/all';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { AbstractComponentPropTypes } from '../../../cms/registries';

export type ShareUserType = Exclude<UserType, UserType.ANONYMOUS | UserType.EMPLOYEE>;

export type ContainerElementProps = {
  children?: JSX.Element;
};

export interface ProfileListInterface {
  iconType?: IconStyle;
  iconName?: IconName;
  imageSrc?: string;
  label: string;
  component: string;
  reDirectUrl?: string;
  target?: string;
  rightIcon?: ReactNode;
  onClick?: () => void;
  ContainerElement?: React.FC<ContainerElementProps>;
}

export type ProfileSectionPropsTypes = {
  title?: string;
  profileData?: Array<ProfileListInterface>;
};

export interface MePanelProps extends AbstractComponentPropTypes {
  data: ProfileSectionPropsTypes[];
  locale?: string;
  langHandler?: (locale: string) => void;
  cartListId?: string;
  closeHandler?: () => void;
}

export enum ProfileComponent {
  signin = 'signin',
  link = 'link',
  signup = 'signup',
  signout = 'signout',
  language = 'language',
  wishlist = 'wishlist',
  sso = 'sso',
  sharebar_member = 'sharebar_member',
  sharebar_abo = 'sharebar_abo',
  sop = 'sop',
  sharebar_customer = 'sharebar_customer',
}
